export default __webpack_public_path__ + "static/media/radio-disabled.42de8910.svg";